import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["childCenters"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

// @flow
import reducersGenerator from './generator'; // Remove all invisible center in center hierarchy

var cleanCenters = function cleanCenters(centers) {
  var ret = [];

  var _iterator = _createForOfIteratorHelper(centers),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var center = _step.value;

      var _center$childCenters2 = center.childCenters,
          childCenters = _center$childCenters2 === void 0 ? [] : _center$childCenters2,
          rest = _objectWithoutProperties(center, _excluded);

      if (center.isVisibleOnline) {
        ret.push(_objectSpread(_objectSpread({}, rest), {}, {
          childCenters: _toConsumableArray(cleanCenters(childCenters))
        }));
      } else {
        ret = ret.concat(_toConsumableArray(cleanCenters(childCenters)));
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return ret;
};

var listReducer = function listReducer(state, action) {
  var _action$shouldClean = action.shouldClean,
      shouldClean = _action$shouldClean === void 0 ? true : _action$shouldClean;
  var centers = action.payload.items.map(function (_ref) {
    var center = _ref.center;
    return center;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    items: shouldClean ? cleanCenters(centers) : centers
  });
};

var centersTreeReducer = reducersGenerator({
  name: 'centersTree',
  surchargeReducer: function surchargeReducer() {
    return {
      GET_LIST_SUCCESS: listReducer,
      SET_ITEMS: listReducer
    };
  }
});
export default centersTreeReducer;
//# sourceMappingURL=centersTree.js.map